import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_soap_11: FaireProductEntity = {
  token: "nyc-soap-11",
  type: "product",
  name: "Upper West Side Face Serum",
  brandName: "Manhattan Skincare Lab",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0df6f03900eccfb61f09216b82f305c98fd7a5cbd623880a66ab7eae38371801.webp",
  priceDollars: 35,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/0df6f03900eccfb61f09216b82f305c98fd7a5cbd623880a66ab7eae38371801.webp",
  weight: 0.2,
  dimensions: {
    width: 2,
    height: 4,
    depth: 2,
  },
  description: "Anti-aging face serum from Upper West Side",
  categoryTokens: ["cat_bath-all"],
  tags: ["nyc-local", "premium", "organic", "luxury"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
